import Banner from "./components/banner";
import About from "./components/about";
import Countdown from "./components/countdown";
import Advantage from "./components/advantage";
import Line from "./components/line";

export default function Home(){
    return     <div>
        <Banner />
        <About />
        <Countdown />
        <Advantage />
        <Line />
    </div>
}
